module.exports = __webpack_public_path__ + "static/img/hz-01.882ff7de.jpg";